var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7724_18039",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7724_18039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 22.6667C11.0444 22.6667 11.3611 22.5389 11.6167 22.2833C11.8722 22.0278 12 21.7111 12 21.3333C12 20.9556 11.8722 20.6389 11.6167 20.3833C11.3611 20.1278 11.0444 20 10.6667 20C10.2889 20 9.97222 20.1278 9.71667 20.3833C9.46111 20.6389 9.33333 20.9556 9.33333 21.3333C9.33333 21.7111 9.46111 22.0278 9.71667 22.2833C9.97222 22.5389 10.2889 22.6667 10.6667 22.6667ZM10.6667 17.3333C11.0444 17.3333 11.3611 17.2056 11.6167 16.95C11.8722 16.6944 12 16.3778 12 16C12 15.6222 11.8722 15.3056 11.6167 15.05C11.3611 14.7944 11.0444 14.6667 10.6667 14.6667C10.2889 14.6667 9.97222 14.7944 9.71667 15.05C9.46111 15.3056 9.33333 15.6222 9.33333 16C9.33333 16.3778 9.46111 16.6944 9.71667 16.95C9.97222 17.2056 10.2889 17.3333 10.6667 17.3333ZM10.6667 12C11.0444 12 11.3611 11.8722 11.6167 11.6167C11.8722 11.3611 12 11.0444 12 10.6667C12 10.2889 11.8722 9.97222 11.6167 9.71667C11.3611 9.46111 11.0444 9.33333 10.6667 9.33333C10.2889 9.33333 9.97222 9.46111 9.71667 9.71667C9.46111 9.97222 9.33333 10.2889 9.33333 10.6667C9.33333 11.0444 9.46111 11.3611 9.71667 11.6167C9.97222 11.8722 10.2889 12 10.6667 12ZM14.6667 22.6667H22.6667V20H14.6667V22.6667ZM14.6667 17.3333H22.6667V14.6667H14.6667V17.3333ZM14.6667 12H22.6667V9.33333H14.6667V12ZM6.66667 28C5.93333 28 5.30556 27.7389 4.78333 27.2167C4.26111 26.6944 4 26.0667 4 25.3333V6.66667C4 5.93333 4.26111 5.30556 4.78333 4.78333C5.30556 4.26111 5.93333 4 6.66667 4H25.3333C26.0667 4 26.6944 4.26111 27.2167 4.78333C27.7389 5.30556 28 5.93333 28 6.66667V25.3333C28 26.0667 27.7389 26.6944 27.2167 27.2167C26.6944 27.7389 26.0667 28 25.3333 28H6.66667ZM6.66667 25.3333H25.3333V6.66667H6.66667V25.3333Z",
    fill: "#1D1D1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj);
export default __webpack_public_path__ + "static/media/obj.317d6bd90570651010ef952ab21907ad.svg";
export { ForwardRef as ReactComponent };